import React from "react";
import { Box, Grid } from "@mui/material";
import {
  InfoOutlined,
  CodeOutlined,
  PublicOutlined,
  Person,
  DateRangeOutlined,
} from "@mui/icons-material";

import { useSmsProviderDetailContext } from "contexts/SmsProviderDetailContext";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { localizeDateTimeShort } from "utils/dateFormats";
import Status from "components/Shared/Status";

const SmsProviderBasicDetail = () => {
  const { smsProviderDetail, loadingSmsProvider } =
    useSmsProviderDetailContext();

  return !loadingSmsProvider ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Name"
            subtitle={smsProviderDetail?.name || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <CodeOutlined color="primary" />}
            title="Script Code"
            subtitle={smsProviderDetail?.scriptCode || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <PublicOutlined color="primary" />}
            title="Country"
            subtitle={smsProviderDetail?.country?.name || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <Person color="primary" />}
            title="Created By"
            subtitle={smsProviderDetail?.createdBy?.name || "N/A"}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <DateRangeOutlined color="primary" />}
            title="Created At"
            subtitle={
              smsProviderDetail?.createdAt
                ? localizeDateTimeShort(smsProviderDetail.createdAt)
                : "N/A"
            }
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={smsProviderDetail?.isActive} />
          </InformationTile>
        </Grid>

        <Grid item xs={12}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Parameters"
            subtitle={
              smsProviderDetail?.parameters?.length
                ? smsProviderDetail.parameters.join(", ")
                : "N/A"
            }
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default SmsProviderBasicDetail;
